import { render, staticRenderFns } from "./ocular-emergency-triage.vue?vue&type=template&id=e5e08acc&scoped=true&lang=pug&"
import script from "./ocular-emergency-triage.vue?vue&type=script&lang=js&"
export * from "./ocular-emergency-triage.vue?vue&type=script&lang=js&"
import style0 from "./ocular-emergency-triage.vue?vue&type=style&index=0&id=e5e08acc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e08acc",
  null
  
)

export default component.exports